'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { AnimatedButton } from '@/components/ui/animated-button';
import { ArrowDownOneZeroIcon, ArrowUpOneZeroIcon } from '@/components/ui/icon/glyphs';
import { SelectField } from '@/components/ui/select-field';
import { cn } from '@/lib/ui/utils';
import { MARKET_TAB_FILTER_TRIGGER_CLASS } from './market-tab-filter-trigger';
export function MarketTableSortControls(t0) {
  const $ = _c(28);
  const {
    sortBy,
    sortOrder,
    options,
    onSortChange,
    onSortOrderChange,
    className
  } = t0;
  const t = useTranslations("market.sort_controls");
  const t1 = className ?? "md:hidden";
  let t2;
  if ($[0] !== t1) {
    t2 = cn("flex items-center gap-2", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("column");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onSortChange || $[5] !== onSortOrderChange || $[6] !== options || $[7] !== sortBy) {
    t4 = value => {
      const selected = options.find(option => option.value === value);
      if (selected === undefined || selected.value === sortBy) {
        return;
      }
      onSortChange(selected.value);
      onSortOrderChange("desc");
    };
    $[4] = onSortChange;
    $[5] = onSortOrderChange;
    $[6] = options;
    $[7] = sortBy;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== options || $[10] !== sortBy || $[11] !== t3 || $[12] !== t4) {
    t5 = <SelectField aria-label={t3} value={sortBy} items={options} containerClassName="flex-1" triggerClassName={MARKET_TAB_FILTER_TRIGGER_CLASS} onValueChange={t4} />;
    $[9] = options;
    $[10] = sortBy;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = sortOrder === "asc" ? ArrowUpOneZeroIcon : ArrowDownOneZeroIcon;
  let t7;
  if ($[14] !== sortOrder || $[15] !== t) {
    t7 = sortOrder === "asc" ? t("ascending") : t("descending");
    $[14] = sortOrder;
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== onSortOrderChange || $[18] !== sortOrder) {
    t8 = () => onSortOrderChange(sortOrder === "asc" ? "desc" : "asc");
    $[17] = onSortOrderChange;
    $[18] = sortOrder;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t6 || $[21] !== t7 || $[22] !== t8) {
    t9 = <AnimatedButton variant="tertiary" size="lg" prefix={t6} aria-label={t7} onClick={t8} />;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t2 || $[25] !== t5 || $[26] !== t9) {
    t10 = <div className={t2}>{t5}{t9}</div>;
    $[24] = t2;
    $[25] = t5;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  return t10;
}